import styles from './StatCard.module.css';

const StatCard = ({ value, label }) => {
    return (
        <div className={`${styles.statCard} p-4 h-100 d-flex flex-column justify-content-between`}>
            <div className={styles.statValue}>{value}</div>
            <div className={`${styles.statLabel} mt-4`}>{label}</div>
        </div>
    );
};

export default StatCard;
